<script lang="ts">
  import { Col, Input, Row } from "sveltestrap"
  import CurrencyBadge from "./CurrencyBadge.svelte"

  export let currency: string;
  export let balance: number;
  export let valid: boolean;
  export let value = 0;
  export let onInput: Function;
</script>

<div class={"token-input-box" + (valid ? '' : ' invalid-value')}>
  <Row>
    <Col>
      <Input class="token-input" placeholder="0.0" value={value} on:input={onInput}/>
    </Col>
    <CurrencyBadge currency={currency}/>
  </Row>
  <Row class="justify-content-end">
    <Col class="col-auto token-input-desc">
      You own: {Number.parseFloat(balance.toFixed(3)).toLocaleString('en')} {currency}
    </Col>
  </Row>
</div>
